import { SET_MESSAGES, MARK_MESSAGE_AS_READ } from "../constants/messages";

export const setMessages = (messages) => ({
  type: SET_MESSAGES,
  payload: messages,
});

export const markMessageAsRead = (messageId) => ({
  type: MARK_MESSAGE_AS_READ,
  payload: messageId,
});
